import { apiSlice } from "./api/apiSlice";

const policySlice = apiSlice.injectEndpoints({
    endpoints:(builder)=>({
        createPolicy:builder.mutation({
            query:(policy)=>({
                url:'policy/create',
                method:'POST',
                body:policy
            }),
            invalidatesTags:['Policy']
        }),

        // RTK Query mutations take a single argument. The old signature was
        // query:(id, policy), so `policy` was always undefined and the PUT body
        // went out empty.
        editPolicy:builder.mutation({
            query:({ id, ...policy })=>({
                url:`policy/${id}`,
                method:'PUT',
                body:policy
            }),
            invalidatesTags:['Policy']
        }),

        deletePolicy:builder.mutation({
            query:(id)=>({
                url:`policy/${id}`,
                method:'DELETE'
            }),
            invalidatesTags:['Policy']
        }),

        // The list response deliberately omits fileAttachment (see the backend
        // policyController). Documents are base64 blobs up to 1 MB each, so
        // including them made the list payload scale with total document size.
        // Use getSinglePolicy to pull one document on demand.
        getAllPolicy:builder.query({
            query:()=>({
                url:'policy'
            }),
            transformResponse:(response)=>response.policy,
            providesTags:['Policy']
        }),

        getSinglePolicy:builder.query({
            query:(id)=>({
                url:`policy/${id}`,
            }),
            transformResponse:(response)=>response.policy,
            providesTags:['Policy']
        })
    })
})


export const {
    useCreatePolicyMutation,
    useEditPolicyMutation,
    useDeletePolicyMutation,
    useGetAllPolicyQuery,
    useGetSinglePolicyQuery,
    useLazyGetSinglePolicyQuery,
} = policySlice;
